import 'core-js/stable'
// import 'babel-polyfill'; /* added for sync await function*/
// import 'babel-core'; /* added for sync await function */
import Vue from 'vue'
//import CoreuiVue from '@coreui/vue/src'
import CoreuiVuePro from '@coreui/vue-pro/src/index.js'
import VueExcelEditor from 'vue-excel-editor';
// 전역 CSS 는 App(CoreUI scss) 보다 먼저 import 한다.
// production 빌드는 vendor CSS(chunk-vendors.css) 가 app.css 보다 먼저 로드되는데, dev 서버는 import 순서대로
// style 태그가 꽂히므로 여기서 순서를 맞추지 않으면 dev 와 prod 의 우선순위(body 글자 크기 등)가 달라진다.
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import App from './App'
import router from './router/index'
import { iconsSet as icons } from './assets/icons/icons.js'
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'

import store from './store'
import i18n from './i18n.js'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(CoreuiVuePro)
Vue.use(VueExcelEditor)


Vue.prototype.$log = console.log.bind(console)

new Vue({
  el: '#app',
  router,
  store,
  //CIcon component documentation: https://coreui.io/vue/docs/components/icon
  icons,
  i18n,
  template: '<App/>',
  components: {
    App
  }
})
